import { NgModule } from "@angular/core";
import { NewsSearchComponent } from "apps-module/app/entry-modules/news-search/news-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { ResultItemComponent } from "apps-module/app/entry-modules/news-search/components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "apps-module/app/entry-modules/news-search/components/search-results/search-results.component";

@NgModule({
    declarations: [
        NewsSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [NewsSearchComponent],
    imports: [
        CommonComponentsModule
    ]
})
export class NewsSearchModule { }
